import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { MESSAGE_FORMAT_CONFIG } from 'ngx-translate-messageformat-compiler';

import { messageFormatConfigFactory } from './message-format-config.factory';

export function provideLocalizationFormatters(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: MESSAGE_FORMAT_CONFIG,
      useFactory: messageFormatConfigFactory,
    }
  ]);
}
